import { useEffect, useState, useCallback } from "react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { SectionTitle, Empty, statusBadge, statusLabel } from "@/admin/ui";
import { toast } from "sonner";

export function AdminReports() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/reports").then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);

  const close = async (r) => { try { await api.post(`/admin/reports/${r.id}/close`); load(); } catch (e) { toast.error(errMsg(e)); } };
  const ban = async (r) => {
    if (!window.confirm(`${r.reported_username} banlansın mı?`)) return;
    try { await api.post(`/admin/users/${r.reported_id}/ban`, { banned: true, ban_ip: true }); await api.post(`/admin/reports/${r.id}/close`); toast.success("Banlandı"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const banReporter = async (r) => {
    if (!window.confirm(`Asılsız ihbar: ${r.reporter_username} banlansın mı?`)) return;
    try { await api.post(`/admin/users/${r.reporter_id}/ban`, { banned: true, ban_ip: true }); await api.post(`/admin/reports/${r.id}/close`); toast.success("İhbarcı banlandı"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <SectionTitle eyebrow="Moderasyon" title="Kullanıcı Bildirimleri (Report)" />
      {rows === null ? <div className="h-40 rounded-2xl bg-slate-900/60 animate-pulse" /> : rows.length === 0 ? <Empty text="Bildirim yok." /> : (
        <div className="space-y-3" data-testid="admin-reports-list">
          {rows.map((r) => (
            <div key={r.id} data-testid="admin-report-item" className="cx-glass rounded-2xl p-5">
              <div className="flex flex-wrap items-center gap-3 justify-between">
                <p className="text-sm"><b className="text-cyan-300">{r.reporter_username}</b> <span className="text-slate-500">→ bildirdi →</span> <b className="text-red-300">{r.reported_username}</b></p>
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] font-mono-cx px-2 py-1 rounded-md border ${statusBadge(r.status)}`}>{statusLabel(r.status)}</span>
                  <span className="text-xs text-slate-500">{fmtDate(r.created_at)}</span>
                </div>
              </div>
              <p className="text-sm text-slate-200 mt-3 bg-slate-950/60 border border-slate-800 rounded-xl p-3">{r.reason}</p>
              {r.status === "open" && (
                <div className="flex flex-wrap gap-2 mt-3">
                  <button data-testid="report-ban-reported" onClick={() => ban(r)} className="h-9 px-3 rounded-lg bg-red-950 border border-red-500/50 text-red-300 text-xs font-semibold">Bildirileni Banla</button>
                  <button data-testid="report-ban-reporter" onClick={() => banReporter(r)} className="h-9 px-3 rounded-lg bg-amber-950 border border-amber-500/50 text-amber-300 text-xs font-semibold">Asılsız İhbar — İhbarcıyı Banla</button>
                  <button data-testid="report-close" onClick={() => close(r)} className="h-9 px-3 rounded-lg bg-slate-900 border border-slate-700 text-slate-300 text-xs font-semibold">Kapat</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
